import localForage from 'localforage';

const safeRun = async (fun) => {
  try {
    const result = await fun();

    return Promise.resolve(result);
  } catch (error) {
    return Promise.resolve(undefined);
  }
};

export default {
  getItem: async (key) => safeRun(() => localForage.getItem(key)),
  removeItem: async (key) => safeRun(() => localForage.removeItem(key)),
  setItem: async (key, value) => safeRun(() => localForage.setItem(key, value)),
  clear: async () => safeRun(() => localForage.clear()),
};
